import {
    CommunicationDTO as Communication,
    CounterExpertiseDTO as CounterExpertise,
    RemarkDTO as Remark,
    SigningDTO as Signing,
    SvsDTOLine as SvsLine,
    ValueAndCauseDTO as ValueAndCause,
    VatAndPaymentDTO as VatAndPayment
} from '../../../business/models/dto/svs/svs.dto';
import { DetailsSvsState, SvsTab } from './types';

import { SvsViews } from './model';

export const ValueAndCause_Initial: ValueAndCause = {
    valueBuildingBeforeAccident: '',
    valueContentBeforeAccident: '',
    damageCauseRemark: '',
    cloneInsuredAmountBuilding: '',
    cloneInsuredAmountContent: '',
    cloned: false
};

export const Communication_Initial: Communication = {
    sendEmailToPolicyHolder: false,
    emailPolicyHolder: '',
    sendEmailToCounterExpert: false,
    emailCounterExpert: '',
    sendEmailToPersonalExpert: false,
    emailPersonalExpert: '',
    sendEmailToOther: false,
    emailOther: '',
    sendDaccaEmailToPolicyHolder: false,
    sendDaccaEmailToCounterExpert: false,
    sendDaccaEmailToPersonalExpert: false,
    sendDaccaEmailToOther: false,
    sent: false
};

export const VatAndPayment_Inital: VatAndPayment = {
    deductibleVatPercentage: '',
    vat6ToBeJustifiedAmount: '',
    vat21ToBeJustifiedAmount: '',
    financialAccountNumber: '', // BBAN
    iban: '',
    bic: ''
};

export const CounterExpertise_Initial: CounterExpertise = {
    nameTP: '',
    nameTPCompany: '',
    referteTP: '',
    realValue: '',
    counterExpertSignedName: '',
    comment: ''
};

export const Remark_Initial: Remark = {
    remarksSelected: false,
    remark: ''
};

export const Signing_Initial: Signing = {
    signatureCounterExpert: '',
    personalExpertSignedName: '',
    signaturePersonalExpert: '',
    signatureExpertOrInspector: '',
    signaturePolicyHolder: '',
    signedOn: '',
    cloneSuffererName: '',
    cloneSuffererLocation: '',
    reflectionTime: true
};

export const initialCurrentLine: SvsLine = {
    id: 0,
    amount: 0,
    description: '',
    lineFormatCode: '',
    sequence: 0,
    svsHeaderID: 0,
    deleted: false,
    isImportFromDacca: false
};

export const initialTabsState: SvsTab[] = [
    { isDirty: false, isSaved: false },
    { isDirty: false, isSaved: false },
    { isDirty: false, isSaved: false },
    { isDirty: false, isSaved: false },
    { isDirty: false, isSaved: false },
    { isDirty: false, isSaved: false },
    { isDirty: false, isSaved: false }
];

export const initialState: DetailsSvsState = {
    currentView: SvsViews.valueAndCause,
    previousView: SvsViews.valueAndCause,

    id: 0,

    valueAndCause: ValueAndCause_Initial,
    communication: Communication_Initial,
    vatAndPayment: VatAndPayment_Inital,
    counterExpertise: CounterExpertise_Initial,
    remark: Remark_Initial,
    signing: Signing_Initial,

    currentLine: initialCurrentLine,
    lines: [],
    lineAmountTotal: 0,
    excessApplicableTC: undefined,
    underConditionTC: undefined,
    SVSApplicationOfTheExemptionTC: [],
    SVSSubjectToTC: [],

    additionalData: {
        insuredPersonName: '',
        insuredAddress: '',
        policySubTypeTC: '',
        contractName: ''
    },

    tabs: initialTabsState,

    svsItems: [],
    svsItemsTabs: {},

    damageCauseRemarkIsValid: false,
    damageRowExcessApplicableIsValid: false,
    damageRowUnderConditionIsValid: false,
    createdByName: '',
    createdByFirstName: '',
    createdByLastName: '',
    createdByCompany: '',
    createdByCompanyDibCode: '',

    locked: false,
    validated: false,
    approved: true,
    validations: []
};
